<div class="content-settings">
  <mat-card *ngIf="isErrorOnVeritoneMarket">
    <button mat-raised-button color="primary" (click)="loadingVeritoneMarket()">
      Loading Veritone Market
    </button>
  </mat-card>
  <mat-card>
    <div class="row">
      <div class="col-sm-12">
        <h4 class="col-sm-auto p-3 station-settings">Station Settings</h4>
        <div class="col-sm-8">
          <div class="col-sm-auto p-2">
            <app-single-dropbox
              data-testid="market"
              class="single-dropbox"
              [isDisabled]="isMarketDisabled"
              [allowMultiple]="false"
              cssClassToApply="dropbox-w-300 single-dropbox-custom"
              popupPositionLeft="1"
              [(ngModel)]="market"
              placeholder="Market *"
              placeholderLabel="Find a market..."
              noEntriesFoundLabel="No market found"
              (selectionChanged)="selectMarket($event)"
              #dropboxMarket
            >
            </app-single-dropbox>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="col-sm-auto p-2">
            <mat-form-field style="width: 315px">
              <input
                required
                #inputVeritoneStationId
                matInput
                type="text"
                maxlength="9"
                placeholder="Veritone Station id"
                aria-label="Veritone"
                [formControl]="veritoneStationIdControl"
                (change)="onChangeVeritone()"
                name="veritoneStationId"

              />
              <mat-error
                *ngIf="
                  stationForm.controls['veritoneStationId'].hasError('pattern')
                "
                >Please enter numeric value.</mat-error
              >
            </mat-form-field>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="col-sm-auto p-2">
            <app-single-dropbox
            (selectionChanged)="onChangeVeritone()"
              data-testid="veritone-market"
              class="single-dropbox"
              [allowMultiple]="false"
              cssClassToApply="dropbox-w-300 single-dropbox-custom"
              popupPositionLeft="1"
              [(ngModel)]="veritoneMarket"
              placeholder="Veritone Market *"
              placeholderLabel="Find a market..."
              noEntriesFoundLabel="No veritone market found"
              (selectionChanged)="selectVeritoneMarket($event)"
              #dropboxVeritoneMarket
            >
            </app-single-dropbox>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card>
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex">
          <h4 class="col-sm-auto p-3">Media Monitors</h4>
          <button
            class="pt-1"
            data-testid="add-mm"
            *ngIf="!stationMediaMonitors?.id && !canAddMediaMonitors"
            mat-icon-button
            (click)="addStationMediaMonitors()"
          >
            <mat-icon color="primary">add_circle</mat-icon>
          </button>
          <button
            class="pt-1"
            *ngIf="!stationMediaMonitors?.id && canAddMediaMonitors"
            mat-icon-button
            (click)="hideStationMediaMonitors()"
          >
            <mat-icon color="primary">remove_circle</mat-icon>
          </button>
          <button
            class="pt-1"  
            *ngIf="stationMediaMonitors?.id && !canAddMediaMonitors"
            mat-icon-button
            (click)="removeStationMediaMonitors()"
          >
            <mat-icon color="primary">delete</mat-icon>
          </button>
        </div>
        <div
          class="row p-3"
          [class.is-hidden]="!stationMediaMonitors?.id && !canAddMediaMonitors"
        >
          <div class="col-4">
            <app-single-dropbox
              data-testid="station-mm"
              class="single-dropbox"
              [isDisabled]="!canAddMediaMonitors"
              [allowMultiple]="false"
              cssClassToApply="dropbox-w-300 single-dropbox-custom"
              popupPositionLeft="1"
              [(ngModel)]="stationMediaMonitors"
              placeholder="Station"
              placeholderLabel="Find a station..."
              noEntriesFoundLabel="No station found"
              (selectionChanged)="selectMediaMonitorsStation($event)"
              #dropboxMediaMonitors
            >
            </app-single-dropbox>
          </div>
          <div class="col-4" *ngIf="stationMediaMonitors?.id">
            <div class="col-sm-auto p-3">
              <p class="text-lg-left font-weight-bold">
                Station ID: {{ stationMediaMonitors?.id }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card>
    <div class="row">
      <div class="col-sm-12">
        <div class="d-flex">
          <h4 class="col-sm-auto p-3">Stream</h4>
          <button
            class="pt-1"
            data-testid="add-stream"  
            *ngIf="!stationStream?.id && !canAddMainStream"
            mat-icon-button
            (click)="addStationMainStream()"
          >
            <mat-icon color="primary">add_circle</mat-icon>
          </button>
          <button
            class="pt-1"  
            *ngIf="!stationStream?.id && canAddMainStream"
            mat-icon-button
            (click)="hideStationMainStream()"
          >
            <mat-icon color="primary">remove_circle</mat-icon>
          </button>
          <button
            class="pt-1"
            data-testid="delete-stream"  
            *ngIf="stationStream?.id && !canAddMainStream"
            mat-icon-button
            (click)="removeStationMainStream()"
          >
            <mat-icon color="primary">delete</mat-icon>
          </button>
        </div>
        <div
          class="row p-3"
          [class.is-hidden]="!canAddMainStream && !stationStream?.id"
        >
          <div class="col-4">
            <app-single-dropbox
              required
              data-testid="station-stream"
              class="single-dropbox"
              [isDisabled]="!canAddMainStream"
              [allowMultiple]="false"
              cssClassToApply="dropbox-w-300 single-dropbox-custom"
              popupPositionLeft="1"
              [(ngModel)]="stationStream"
              placeholder="Station"
              placeholderLabel="Find a station..."
              noEntriesFoundLabel="No station found"
              (selectionChanged)="selectMainStreamStation($event)"
              #dropboxStream
            >
            </app-single-dropbox>
          </div>
          <div class="col-4" *ngIf="stationStream?.id">
            <div class="col-sm-auto p-3">
              <p class="text-lg-left font-weight-bold">
                Station ID: {{ stationStream?.id }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card *ngIf="showCustomSources">
    <div class="row">
      <div class="col-sm-12">
        <h4 class="col-sm-auto p-3">Custom Sources</h4>
        <div class="row p-2">
          <div class="col-sm-auto button-add-source">
            Add Source
            <button
              data-testid="add-source-button"
              [disabled]="!showCustomSources"
              mat-icon-button
              (click)="addCustomSource()"
            >
              <mat-icon color="primary">add_circle</mat-icon>
            </button>
          </div>
        </div>
        <div class="row p-4" *ngIf="dataSource.length > 0">
          <table
            mat-table
            [dataSource]="dataSource"
            class="mat-elevation-z8 demo-table"
          >
            <!-- Type Column -->
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef>Type</th>
              <td mat-cell *matCellDef="let element">
                {{ element.stationSource.name }}
              </td>
            </ng-container>

            <!-- Station Id Column -->
            <ng-container matColumnDef="stationId">
              <th mat-header-cell *matHeaderCellDef>Station Id</th>
              <td mat-cell *matCellDef="let element">{{ element.id }}</td>
            </ng-container>

            <!-- action Column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element">
                <button
                  mat-icon-button
                  class="table-btn"
                  matTooltip="Remove"
                  (click)="deleteStation(element)"
                >
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="displayedColumns; sticky: true"
            ></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </div>
      </div>
    </div>
  </mat-card>
  <mat-card>
    <div class="button-row">
      <button
        [disabled]="isSubmitButtonDisable()"
        data-testid="confirm-button"
        mat-raised-button
        class="confirm"
        (click)="submit()"
      >
        Confirm
      </button>
      <button
        data-testid="cancel-button"
        mat-raised-button
        color="accent"
        (click)="createStationAndCancel()"
      >
        Cancel
      </button>
    </div>
  </mat-card>
</div>
